import api from "./api";

export interface LoginRequest {
  userName: string;
  password: string;
  workstationId?:number
  date?:string
}

export const login = async (credentials: LoginRequest) => {
  return await api.post("/auth/login", credentials);
};
export const loginWithSession = async (credentials: LoginRequest) => {
  return await api.post("/auth/login-createSession", credentials);
};
export const checkAdmin = async (credentials: LoginRequest) => {
  return await api.post("/auth/checkAdmin", credentials);
};
